import {
  LocationEntity,
  EntranceEntity,
  ScanningAppData,
  ScanningQueryStringParameters,
  GetLocationOptions,
  CurrentScanningLocation,
  GetCurrentScanningLocationOptions,
  GetAllLocationsOptions,
  GetAllEntrancesOptions,
} from '../../../../types';
import { logError, apiGetRequest } from '../../helpers';

const apiBaseURL = process.env.VUE_APP_API_URL || '';

const appData: ScanningAppData = {
  queryParameters: {
    externalUserId: null,
    apiKey: null,
    customerId: null,
    locationId: null,
    securityScanningCode: null,
    lang: 'en',
    cssURL: null,
    primaryColor: '#00B5EF',
    primaryFontColor: '#00B5EF',
    primaryButtonFontColor: '#FFF',
    secondColor: '#00B5EF',
    secondFontColor: '#00B5EF',
    secondButtonFontColor: '#FFF',
    headerBackgroundColor: '#1E1B1D',
    approveColor: '#238823',
    denyColor: '#D2222D',
  },
  locations: [],
  entrances: [],
  currentScanningLocation: {
    id: null,
    entranceId: null,
    securityScanningCode: null,
    lastDataPull: null,
  },
  loading: false,
};

export default {
  namespaced: true,
  state: appData,
  getters: {
    QUERY_PARAMETERS: (state: ScanningAppData) => state.queryParameters,
    LOCATIONS: (state: ScanningAppData) => state.locations,
    ENTRANCES: (state: ScanningAppData) => state.entrances,
    LOADING: (state: ScanningAppData) => state.loading,
    CURRENT_SCANNING_LOCATION: (state: ScanningAppData) => state.currentScanningLocation,
  },
  mutations: {
    REMOVE_EXISTING_DATA: (state: ScanningAppData) => {
      state.locations = [];
      state.entrances = [];
    },
    REMOVE_LOGIN_DATA: (state: ScanningAppData) => {
      state.currentScanningLocation.id = null;
      state.currentScanningLocation.securityScanningCode = null;
      state.currentScanningLocation.lastDataPull = null;
    },
    SET_LOADING: (state: ScanningAppData, payload: boolean) => {
      state.loading = payload;
    },
    SET_QUERY_PARAMETERS: (state: ScanningAppData, payload: ScanningQueryStringParameters) => {
      state.queryParameters = payload;
    },
    SET_LOCATION: (state: ScanningAppData, payload: LocationEntity) => {
      const existingArrayIndex = state.locations.findIndex((location) => location.id === payload.id);

      if (existingArrayIndex !== -1) {
        state.locations[existingArrayIndex] = payload;
      } else {
        state.locations.push(payload);
      }
    },
    SET_LOCATIONS: (state: ScanningAppData, payload: LocationEntity[]) => {
      state.locations = payload;
    },
    SET_ENTRANCES: (state: ScanningAppData, payload: EntranceEntity[]) => {
      state.entrances = payload;
    },
    SET_CURRENT_SCANNING_LOCATION: (state: ScanningAppData, payload: CurrentScanningLocation) => {
      state.currentScanningLocation = payload;
    },
    SET_CURRENT_SCANNING_LOCATION_ENTRANCE: (state: ScanningAppData, payload: number | null) => {
      state.currentScanningLocation.entranceId = payload;
    },
  },
  actions: {
    GET_CURRENT_SCANNING_LOCATION: async ({ commit, dispatch }: any, options: GetCurrentScanningLocationOptions) => {
      await dispatch('GET_LOCATION', options);
      await dispatch('GET_ALL_ENTRANCES', options);

      const currentScanningLocation: CurrentScanningLocation = {
        id: options.locationId,
        lastDataPull: +new Date(),
        securityScanningCode: options.securityScanningCode,
        entranceId: null,
      };

      commit('SET_CURRENT_SCANNING_LOCATION', currentScanningLocation);
    },
    GET_LOCATION: async ({ commit }: any, options: GetLocationOptions) => {
      const apiReturn = await apiGetRequest({
        apiKey: options.apiKey || '',
        apiURL: `${apiBaseURL}customer/${options.customerId}/location/${options.locationId}`,
      });

      if (apiReturn !== null) {
        commit('SET_LOCATION', apiReturn);
      }
    },
    GET_ALL_LOCATIONS: async ({ commit }: any, options: GetAllLocationsOptions) => {
      const apiReturn = await apiGetRequest({
        apiKey: options.apiKey || '',
        apiURL: `${apiBaseURL}customer/${options.customerId}/locations`,
      });

      apiReturn.forEach((value: LocationEntity, index: number) => {
        delete value.otherSettings;

        if (index !== 0) {
          delete value.translations;
          delete value.visualSettings;
        }
      });

      if (apiReturn !== null) {
        commit('SET_LOCATIONS', apiReturn);
      }
    },
    GET_ALL_ENTRANCES: async ({ commit }: any, options: GetAllEntrancesOptions) => {
      const apiReturn = await apiGetRequest({
        apiKey: options.apiKey || '',
        apiURL: `${apiBaseURL}customer/${options.customerId}/location/${options.locationId}/entrances`,
      });

      if (apiReturn !== null) {
        commit('SET_ENTRANCES', apiReturn);
      }
    },
  },
};
